<template>
  <section v-if="bgLayout === 'center'" class="center-login-form">
    <p class="center-login-form-title" @click="updateType === 'forget' ? $emit('on-back', 'mobile') : $emit('on-back'), doResetForm()">
      <Icon size="44" class="icon" type="md-arrow-dropleft" :style="{ 'color': settingData.inputBorderColor }"/>
      <span :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.xgmm') }}</span>
    </p>
    <div class="center-login-form-input" :style="{ 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejimima"></use>
        </svg>
      </span>
      <Input class="input-self" v-model="changeFormValidate.changePassword" :border="false" v-on:input="pwdChange" :placeholder="$t('loginPage.xmm')" type="password" password :style="{ 'color': settingData.fontColor }"/>
    </div>
    <div class="center-login-form-input" :style="{ 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejimima"></use>
        </svg>
      </span>
      <Input class="input-self" v-model="changeFormValidate.changePasswordCheck" :border="false" v-on:input="inconsistentChange" :placeholder="$t('loginPage.qrxmm')" type="password" password :style="{ 'color': settingData.fontColor }"/>
    </div>
    <div class="error-msg" v-show="errMsgFlag">
      <div>
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="!fontFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="fontFlag" />
        {{ $t('loginPage.cdbzf') }}
      </div>
      <div>
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="!pwdFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="pwdFlag" />
        {{ $t('loginPage.sgcfzf') }}
      </div>
      <div>
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="useFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="!useFlag" />
        {{ $t('loginPage.bbhyhm') }}
      </div>
      <div>
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="!fourFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="fourFlag" />
        {{ $t('loginPage.bhtszf') }}
      </div>
      <div v-show="inconsistent">
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="!consistentFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="consistentFlag" />
        {{$t('loginPage.mmbyz')}}
      </div>
      <div class="qd-msg" id="tips">
        <div class="msg-item">弱</div>
        <div class="msg-item"></div>
        <div class="msg-item"></div>
        <div class="msg-item">强</div>
      </div>
    </div>
    <p style="padding: 0 24px;">{{ $t('mmzs') }}</p>
    <button @click="doChangeConfirm" :disabled="!(changeFormValidate.changePassword && changeFormValidate.changePasswordCheck)" class="center-login-button" :style="{ 'background-color': settingData.buttonColor }">{{ $t('qd') }}</button>
  </section>
  <section v-else class="right-login-form">
    <p class="right-login-form-title">
      <Icon size="24" class="icon" type="md-arrow-back" :style="{ 'color': settingData.inputBorderColor }" @click="updateType === 'forget' ? $emit('on-back', 'mobile') : $emit('on-back'), doResetForm()"/>
      <span :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.xgmm') }}</span>
    </p>
    <div class="right-login-form-input" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon"><Icon size="20" type="ios-lock-outline" :style="{ 'color': settingData.inputBorderColor }"/></span>
      <Input class="input-self" v-model="changeFormValidate.changePassword" :border="false" :placeholder="$t('loginPage.xmm')" type="password" password v-on:input="pwdChange" :style="{ 'color': settingData.fontColor }"/>
    </div>
    <div class="right-login-form-input" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon"><Icon size="20" type="ios-lock-outline" :style="{ 'color': settingData.inputBorderColor }"/></span>
      <Input class="input-self" :border="false" size="large"  v-model="changeFormValidate.changePasswordCheck" v-on:input="inconsistentChange" :placeholder="$t('loginPage.qrxmm')" type="password" password :style="{ 'color': settingData.fontColor }"/>
    </div>
    <div class="error-msg" v-show="errMsgFlag">
      <div>
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="!fontFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="fontFlag" />
        {{ $t('loginPage.cdbzf') }}
      </div>
      <div>
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="!pwdFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="pwdFlag" />
        {{ $t('loginPage.sgcfzf') }}
      </div>
      <div>
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="useFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="!useFlag" />
        {{ $t('loginPage.bbhyhm') }}
      </div>
      <div>
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="!fourFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="fourFlag" />
        {{ $t('loginPage.bhtszf') }}
      </div>
      <div v-show="inconsistent">
        <Icon
          type="ios-checkmark-circle-outline"
          color="green"
          size="18"
          v-show="!consistentFlag" />
        <Icon
          type="ios-close-circle-outline"
          color="red"
          size="18"
          v-show="consistentFlag" />
        {{$t('loginPage.mmbyz')}}
      </div>
      <div class="qd-msg" id="tips">
        <div class="msg-item">弱</div>
        <div class="msg-item"></div>
        <div class="msg-item"></div>
        <div class="msg-item">强</div>
      </div>
    </div>
    <p style="padding: 0 24px;">{{ $t('mmzs') }}</p>
    <button @click="doChangeConfirm" :disabled="!(changeFormValidate.changePassword && changeFormValidate.changePasswordCheck)" class="right-login-button" :style="{ 'background-color': settingData.buttonColor }">{{ $t('qd') }}</button>
  </section>
</template>

<script>
/* eslint-disable*/
import { session, cookie } from '@/libs/location'

export default {
  name: 'updatePassword',
  props: {
    userInfo: {
      type: Object,
      default: () => {}
    },
    // initial,修改初始密码；forget；忘记密码下一步；expired，密码过期
    updateType: {
      type: String
    },
    // 忘记密码页面返回信息
    forgetData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      errMsgFlag: false,
      qdMsgFlag: 0, // 密码强度校验
      fontFlag: false, // 长度至少为 10 个字符
      pwdFlag: false,
      useFlag: false, // 不允许与用户名相同
      fourFlag: false, // 至少包括 4 种字符
      inconsistent: false, // 两次密码不一致校验
      consistentFlag: false, // 两次密码不一致标志
      bgLayout: 'center',
      changeFormValidate: {
        oldPassword: '',
        changePassword: '',
        changePasswordCheck: ''
      }
    }
  },
  computed: {
    settingData () {
      return this.$store.state.settingData
    }
  },
  created () {
    this.bgLayout = this.$store.state.settingData.bgLayout
  },
  methods: {
    // 修改密码检验
    pwdChange (data) {
      // console.log('1111')
      this.qdMsgFlag = 0

      if (this.changeFormValidate.changePassword) {
        this.errMsgFlag = true
      } else {
        this.errMsgFlag = false
      }
      if (this.changeFormValidate.changePassword.length >= 8) {
        this.fontFlag = false
        this.qdMsgFlag += 1
      } else {
        this.fontFlag = true
      }
      let reg = !window.document.location.origin.includes('hello.') ? /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/]).{4,30}$/ : /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[@#])[\da-zA-Z~@#]{4,30}$/

      if (reg.test(this.changeFormValidate.changePassword)) {
        this.fourFlag = false
        this.qdMsgFlag += 1
      } else {
        this.fourFlag = true
      }
      let LxStr = function (str) {
        var arr = str.split('')
        var flag = true
        for (var i = 1; i < arr.length - 1; i++) {
          var firstIndex = arr[i - 1].charCodeAt()
          var secondIndex = arr[i].charCodeAt()
          var thirdIndex = arr[i + 1].charCodeAt()
          if ((thirdIndex - secondIndex === 1) && (secondIndex - firstIndex === 1)) {
            flag = false
          }
        }
        if (!flag) {
          return flag
        }
        return flag
      }
      // 不能连续字符（如123、abc）连续3位或3位以上
      // 不能相同字符（如111、aaa）连续3位或3位以上
      let re = /(\w)*(\w)\2{2}(\w)*/g
      if (!LxStr(this.changeFormValidate.changePassword) || re.test(this.changeFormValidate.changePassword)) {
        this.pwdFlag = true
      } else {
        this.pwdFlag = false
        this.qdMsgFlag += 1
      }
      // 密码中不能包含用户名
      let userName = JSON.parse(session.getItem('userInfo')).userName
      if (this.changeFormValidate.changePassword.includes(userName) || this.reverseString(this.changeFormValidate.changePassword).includes(userName)) {
        this.useFlag = false
      } else {
        this.useFlag = true
        this.qdMsgFlag += 1
      }
      const tips = document.getElementById('tips').getElementsByTagName('div')

      switch (this.qdMsgFlag) {
        case 0:
          break
        case 1:
          tips[0].style.backgroundColor = 'red'
          tips[0].innerText = this.$t('loginPage.rx')
          tips[1].style.backgroundColor = 'lightGray'
          tips[2].style.backgroundColor = 'lightGray'
          tips[3].style.backgroundColor = 'lightGray'
          tips[3].innerText = ''
          break
        case 2:
          tips[0].style.backgroundColor = 'red'
          tips[0].innerText = this.$t('loginPage.rx')
          tips[1].style.backgroundColor = 'lightGray'
          tips[2].style.backgroundColor = 'lightGray'
          tips[3].style.backgroundColor = 'lightGray'
          tips[3].innerText = ''
          break
        case 3:
          tips[0].style.backgroundColor = 'red'
          tips[0].innerText = this.$t('loginPage.rx')
          tips[1].style.backgroundColor = 'lightGray'
          tips[2].style.backgroundColor = 'lightGray'
          tips[3].style.backgroundColor = 'lightGray'
          tips[3].innerText = ''
          break
        case 4:
          tips[0].style.backgroundColor = 'lightGray'
          tips[0].innerText = ''
          tips[1].style.backgroundColor = 'lightGray'
          tips[2].style.backgroundColor = 'lightGray'
          tips[3].style.backgroundColor = 'lightGreen'
          tips[3].innerText = this.$t('loginPage.qd')
          break
      }
    },
    // 两次密码不一致检验
    inconsistentChange() {
      if (this.changeFormValidate.changePassword) {
        this.inconsistent = true
      } else {
        this.inconsistent = false
      }
      if (this.changeFormValidate.changePassword !== this.changeFormValidate.changePasswordCheck) {
        this.consistentFlag = true
      } else {
        this.consistentFlag = false
      }
    },
    reverseString (str) {
      return str.split('').reverse().join('')
    },
    // 修改初始密码-确定
    doChangeConfirm () {
      if (this.changeFormValidate.changePassword !== this.changeFormValidate.changePasswordCheck) {
        this.consistentFlag = true
        this.inconsistent = true
      } else {
        this.consistentFlag = false
      }
      if (this.fontFlag) {
        return false
      }
      if (this.pwdFlag) {
        return false
      }
      if (!this.useFlag) {
        return false
      }
      if (this.fourFlag) {
        return false
      }
      if (this.consistentFlag) {
        return false
      }
      let req = {
        id: this.updateType === 'forget' ? this.forgetData.id : JSON.parse(session.getItem('userInfo')).id,
        password: this.changeFormValidate.changePassword
      }
      // console.log('req')
      this.$request.post('/sso/login/checkUpdatePwd', req).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          // 设置语言和皮肤
          this.$i18n.locale = data.languageSign
          this.$store.dispatch('doChangeSkin', data.skinColor)

          session.setObject(data.sessionId)
          session.setItem('userInfo', JSON.stringify(data))
          cookie.setCookie('token', data.sessionId)
          cookie.setCookie('userInfo', JSON.stringify(data))
          if (!window.document.location.origin.includes('hello.')) {
            this.$router.push({ name: 'home' })
          } else {
            this.$router.push({ name: 'home_old' })
          }
        }
      })
    },
    // 重置表单
    doResetForm () {
      this.changeFormValidate.changePassword = ''
      this.changeFormValidate.changePasswordCheck = ''
      this.changeFormValidate.oldPassword = ''
    }
  }
}
</script>
<style scoped lang="less">
.error-msg{
  padding: 0 24px;
  margin-bottom: 20px;
  .qd-msg{
    display: flex;
    justify-content: space-between;
    text-align: center;
    color: #fff;
    margin-top: 10px;
    .msg-item{
      width: 24%;
      height: 12PX;
      line-height: 12PX;
      background: #fff;
    }
  }
}
</style>
